<template>
  <!--
    @param {Object} terms 条款信息对象
    @param {String} title 标题
    @param {String} width 定制宽度，默认30%
    @returns {Object} obj 返回传入的条款编号和是否同意该条款、
    @returns {Object} cookieDialog 用于识别是否是cookie弹窗，特殊处理
    用法：
      html <el-terms-dialog
              :terms="terms"
              @agree="isAgree"
            />
      js  terms: {
            show: false,
            type: 0,
            width: '50%'
          },
          isAgree(item) {//...}
 -->
  <el-dialog
    v-if="terms.show"
    class="terms-dialog"
    aria-posinset="absolute"
    :visible.sync="terms.show"
    top="10vh"
    :append-to-body="true"
    width="60%"
    :before-close="disagreeBtn"
    @agree="isAgree"
  >
    <div slot="title">
      <span class="dialog-title">{{ terms.title }}</span>
    </div>
    <!-- <iframe
      v-if="src"
      :src="src"
      class="termsIframe"
      frameborder="0"
    /> -->
    <div class="content">
      <el-scrollbar ref="scroll" style="height:100%">
        <div ref="contentHtml" class="content-html" v-html="content" />
      </el-scrollbar>
    </div>
    <div v-if="btnShow" slot="footer" class="dialog-footer">
      <!-- 非cookie -->
      <span v-if="!cookieDialog">
        <span v-if="isFromThirdPartner && !isTimeEnough">{{ $t('register.timeCount', {count: timeCount}) }}</span>
        <span v-else-if="isFromThirdPartner && isTimeEnough && !isScrolledBottom">{{ $t('register.readBottom') }}</span>
        <!-- 从copyright进入隐私政策的时候，按钮文案变成关闭 -->
        <el-button v-if="entryFrom === 'copyright'" type="primary" @click="termsBtn(true)">{{ $t('tagsView.close') }}</el-button>
        <el-button v-else :disabled="btnDisabled" type="primary" @click="termsBtn(true)">{{ getBtnName }}</el-button>
        <el-button v-if="showDisagree" @click="disagreeBtn">{{ $t('standard.disagree') }}</el-button>
      </span>
      <!-- cookie -->
      <span v-else slot="footer">
        <div class="cookie-type">
          <el-checkbox v-model="coookieType.agree" @change="handleCookieType">{{ $t('cookies.preference') }}</el-checkbox>
          <span v-if="!coookieType.agree" class="cookie-checkbox" @click="handleDisabled">
            <el-checkbox v-model="coookieType.optimisation" :disabled="!coookieType.agree">{{ $t('cookies.optimisation') }}</el-checkbox>
            <el-checkbox v-model="coookieType.analytics" :disabled="!coookieType.agree">{{ $t('cookies.analytics') }}</el-checkbox>
          </span>
          <el-checkbox v-if="coookieType.agree" v-model="coookieType.optimisation" :disabled="!coookieType.agree">{{ $t('cookies.optimisation') }}</el-checkbox>
          <el-checkbox v-if="coookieType.agree" v-model="coookieType.analytics" :disabled="!coookieType.agree">{{ $t('cookies.analytics') }}</el-checkbox>
        </div>
        <el-button type="primary" @click="termsBtn(true)">{{ $t('standard.define') }}</el-button>
        <el-button @click="disagreeBtn">{{ $t('standard.cancel') }}</el-button>
      </span>

    </div>

  </el-dialog>
</template>

<script>
import { getLatestTermRichTextApi } from '@/api/common/public'
import { onlySaveNecessityCookie, removeOptimisationCookie, removeAnalyticsListCookie } from '@/utils/cookieOperation'
import Cookies from 'js-cookie'
import { getsignContent } from '@/api/protocol/sign'
import { getUrlKey } from '@/utils/index'
import { mapGetters, mapMutations } from 'vuex'
import { TERM_USER } from '@/utils/constant'

export default {
  // 隐私政策，服务条款，cookies政策对话框组件
  name: 'DialogTermsAndPolicy',

  props: {
    btnShow: {
      type: Boolean,
      default: true
    },
    sign: {
      type: Boolean,
      default: false
    },
    terms: {
      type: Object,
      required: true,
      title: {
        type: String,
        default: 'title'
      },
      show: {
        type: Boolean,
        default: false
      }
    },
    showDisagree: {
      type: Boolean,
      default: false
    },
    // 用于识别是否是cookie弹窗，特殊处理
    cookieDialog: {
      type: Boolean,
      default: false
    },
    // 用于识别是否是从copyright组件入口，特殊处理
    entryFrom: {
      type: String,
      default: ''
    },
    isservice: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      content: '',
      coookieType: {
        agree: false,
        optimisation: false,
        analytics: false,
        id: ''
      },
      isTimeEnough: true,
      isScrolledBottom: true,
      timer: null,
      timeCount: 10,
    }
  },
  computed: {
    ...mapGetters(['isAgreeFirst', 'isAgreeSecond', 'defaultCookieId', 'uiConfig']),
    cookieKey() {
      return this.uiConfig.cookieKey || 1
    },
    isFromThirdPartner() {
      return this.$route.name === 'Register' && getUrlKey('sysCode') === 'SFBUY' && getUrlKey('from') // SFBUY跳转过来，注册协议
    },
    btnDisabled() {
      return this.isFromThirdPartner && (!this.isTimeEnough || !this.isScrolledBottom)
    },
    getBtnName() {
      let str = ''
      if (this.terms.type === 101) {
        return this.$t('standard.confirm')
      }
      if (this.showDisagree) {
        str = this.$t('standard.agree')
      } else {
        if (this.isservice) {
          str = this.$t('standard.agreeService')
        } else {
          str = this.$t('standard.agreeAndContinue')
        }
        if (this.terms.type === TERM_USER) {
          str = this.$t('standard.agreeUserAgreement')
        }
      }
      return str
    },
  },
  watch: {
    'terms.show': {
      async handler(n, o) {
        if (n) {
          !this.sign && await this.getLatestTermRichText(this.terms.type)
          this.sign && await this.getsignContentTextFn(this.terms.type)
          if (Cookies.get('option.preference') && this.cookieDialog) {
            this.coookieType = JSON.parse(Cookies.get('option.preference'))
            // 防止用户控制台修改cookie的agree属性，其他值没跟着改变
            if (!this.coookieType.agree) {
              this.coookieType.optimisation = false
              this.coookieType.analytics = false
            }
          }
          if (this.isFromThirdPartner) {
            // console.log(this.isAgreeFirst, this.timer, this.isTimeEnough, this.isScrolledBottom)
            this.$nextTick(() => {
              // 之前已同意过阅读，按钮直接高亮，若刷新页面，重新判断阅读的逻辑
              this.isFinshedRead()
              this.handleScroll()
              this.setTimer()
            })
          }
        } else {
          this.content = ''
        }
      }
    },
  },
  methods: {
    ...mapMutations({
      setAgreeFirst: 'user/SET_AGREE_FIRST',
      setAgreeSecond: 'user/SET_AGREE_SECOND'
    }),
    async getLatestTermRichText(type) {
      try {
        const res = await getLatestTermRichTextApi({ type })
        if (res.success) {
          this.content = res.data.content
          // this.content =
          // if (this.cookieDialog) {
          //   this.coookieType.id = `${res.data.lang}/${res.data.id}`
          // }
          //   '<h1 style="text-align: center;"><p style="text-align: left;"><span style="font-size: small; font-weight: normal;">最后修改日期：2016 年 1 月 20 日</span></p><p style="text-align: left;"><span style="font-size: medium;">欢迎使用顺丰快递！</span></p><p style="text-align: left;"><span style="font-weight: normal; font-size: medium;">感谢您使用由顺丰速运有限公司提供的产品及服务！顺丰速运有限公司位于中国广东省深圳市科技园南侧的学府路的深圳软件产业基地，邮编 518054。使用本公司服务意味着您将同意以下条款，请仔细阅读。我们的服务范围非常广泛，因此有时还会适用一些附加条款或产品要求（包括年龄要求）。附加条款将会与相关服务一同提供，并且在您使用这些服务后，成为您与我们所达成的协议的一部分。</span></p></h1><h1 style="text-align: center;"><div style="text-align: left;"><p><span style="font-size: medium;">使用我们的产品服<span style="font-weight: normal;"></span>务</span></p><p><span style="font-size: medium; font-weight: normal;">在使用产品服务时请遵守所有政策。请不要滥用我们的服务。例如请勿干扰我们的产品服务的正常使用或尝试通过我们提供的界面和说明以外的方法去访问我们的产品服务。请在法律允许范围内使用我们的产品服务。如果您没有遵守我们的条款和条例或者被发现存在任何不当的行为，我们将暂停或停止为您提供服务。使用我们的服务并不让您拥有我们的服务或您所访问的内容的任何知识产权。在没有得到官方的允许或在法律许可时，请不要随意使用我们的产品服务的任何内容。这些产品服务条款并没有赋予您使用我们的产品服务的标志或商标的权利。请勿删除、隐藏或更改我们服务上显示的或随服务一同显示的任何法律声明。在您使用服务的过程中，我们可能会给您发送服务公告、管理消息和其他信息。您可以选择不接收上述某些信息。您可以在移动设备上使用我们的产品服务，但是请不要在开车或其他法律不允许的情况下使用。</span></p><p><span style="font-size: medium;">您的顺丰账户</span></p><p><span style="font-weight: normal; font-size: medium;">当您在使用我们的产品服务时，您可能需要创建一个顺丰快递的账户。您可以自行创建属于您自己的顺丰快递账户，或者由管理者分配给您，比如您的管理员或教育机构。如果您的顺丰账户是由管理者分配给您的，可能需要遵守另外的条款或附加条款，同时您的管理者也将能够使用或停用您的账账户。为了保护您的账号安全，请妥善保管好您的密钥。您将为通过或使用您的账户所发生的所有行为负责。请尽量不要在第三方应用上使用与您的顺丰账户相同的密钥。如果您发现任何未经过您的同意而使用您的密钥或账户的情况，请及时联系我们的工作人员。</span></p></div></h1><div><p></p></div>'
        }
        // else {
        //   this.content = ''
        //   this.$message.error(res.msg)
        // }
      } catch (error) {
        this.content = ''
        console.log(error)
      }
    },
    async getsignContentTextFn(type) {
      try {
        const res = await getsignContent({ termRichTextId: type })
        if (res.success) {
          this.content = res.data.content
        }
      } catch (error) {
        this.content = ''
        console.log(error)
      }
    },
    termsBtn(agree) {
      this.terms.show = false
      if (this.terms.type === 4 || this.terms.type === TERM_USER || this.terms.type === 63) {
        this.$emit('agreeBtn', this.terms)
      }
      if (this.cookieDialog) {
        this.coookieType.id = this.defaultCookieId
        this.coookieType[`id_${this.cookieKey}`] = this.defaultCookieId
        // 根据用户选择的cookie选项清除对应的cookie
        if (!this.coookieType.agree) {
          onlySaveNecessityCookie()
        }
        if (!this.coookieType.optimisation) {
          removeOptimisationCookie()
        }
        if (!this.coookieType.analytics) {
          removeAnalyticsListCookie()
        }
        this.$emit('agree', this.coookieType)
        location.reload()
      } else {
        const obj = {
          type: this.terms.type,
          agree
        }
        this.$emit('agree', obj)
        if (this.isFromThirdPartner) { // 对于第三方过来的注册协议才有控制阅读要求
          // 设置2个协议为已同意，更新缓存状态
          if (this.terms.type === 5) {
            this.setAgreeFirst(true)
          } else if (this.terms.type === 4) {
            this.setAgreeSecond(true)
          }
          // 清除定时器
          this.timer && clearInterval(this.timer)
          this.timer = null
        }
      }
    },
    disagreeBtn() {
      this.terms.show = false
      this.$emit('disagree', false)
      this.timer && clearInterval(this.timer)
      this.timer = null
      this.timeCount = 10
      if ((this.terms.type === 5 && !this.isAgreeFirst) || (this.terms.type === 4 && !this.isAgreeSecond)) {
        this.isTimeEnough = false
        this.isScrolledBottom = false
      }
    },
    isAgree() {
      // console.log('同意')
    },
    // 处理cookie类别选择
    handleCookieType() {
      if (!this.coookieType.agree) {
        this.coookieType.optimisation = false
        this.coookieType.analytics = false
      }
    },
    handleDisabled() {
      this.$message.warning(this.$t('cookies.neddCheck'))
    },
    handleScroll() {
      const contentHtmlEle = this.$refs?.contentHtml
      const wrap = this.$refs.scroll?.wrap
      if (wrap?.clientHeight >= contentHtmlEle?.clientHeight) {
        this.isScrolledBottom = true
        return
      }
      this.scrollBottomJudge(wrap, 'isScrolledBottom')
    },
    scrollBottomJudge(element, scrollBottomFlag) {
      element.onscroll = (e) => {
        const { scrollTop, scrollHeight, clientHeight } = e.target
        // 浏览器屏幕缩放比调整后，clientHeight + scrollTop会出现小数点,导致和scrollHeight不相等 ，所以需要向上取整并大于等于
        if (Math.ceil(clientHeight + scrollTop) >= scrollHeight) { // 滚动条滚到了底部
          this[scrollBottomFlag] = true
        }
      }
    },
    setTimer() {
      this.timer = setInterval(() => {
        this.timeCount--
        if (this.timeCount <= 0) {
          clearInterval(this.timer)
          this.isTimeEnough = true
        }
      }, 1000)
    },
    isFinshedRead() {
      if ((this.terms.type === 5 && !this.isAgreeFirst) || (this.terms.type === 4 && !this.isAgreeSecond) || (this.terms.type === 51 && !this.isAgreeSecond) || (this.terms.type === 52 && !this.isAgreeThird)) { // 第1个，第2个协议
        this.timer = null
        this.timeCount = 10
        this.isTimeEnough = false
        this.isScrolledBottom = false
      } else {
        return
      }
    },
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';
.terms-dialog {
  ::v-deep .el-dialog__header {
    border-bottom: 1px solid $color07;
    padding: 16px 24px 0px;
  }
  ::v-deep .el-dialog__headerbtn {
    top: 15px;
    right: 24px;
  }
  ::v-deep .el-dialog__body {
    padding: 0 10px;
    margin: 4px 0 0;
    border-bottom: 1px solid $color07;
  }
  ::v-deep .el-dialog__footer {
    padding: 16px 24px;
  }
  ::v-deep .el-scrollbar__wrap {
    overflow-x: hidden;
  }
}
.dialog-title{
  display: inline-block;
  font-size: 16px;
  font-weight: bold;
  color: $color02;
  padding-bottom: 12px;
  border-bottom:3px solid $bgHighlight;
}
.termsIframe {
  width: 100%;
  height: 58vh;
}
.content {
  height: 480px;
}
.content-html{
  padding: 0 14px;
  text-align: initial;
  font-size: 14px;
}
.cookie-checkbox{
  margin-left: 30px;
}
.cookie-type{
  text-align: left;
  margin-left: 16px;
}
</style>
<style lang="scss">
@import "@/styles/wangeditor.scss";
</style>
